import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import XIcon from '../../../assets/icons/x_icon.svg';
import {
  Container,
  Overlay,
  Panel,
  PanelHeader,
  CloseButton,
  PanelBody,
  PanelFooter,
} from './css';

const LeftSideBar = ({
  isOpen,
  toggleMenu,
  children,
  footer,
  showScrollbar = false,
  panelBodyBottom,
}) => (
  <Container isOpen={isOpen}>
    <Overlay onClick={() => toggleMenu(false)} />
    <Panel>
      <PanelHeader>
        <CloseButton onClick={() => toggleMenu(false)}>
          <object type="image/svg+xml" data={XIcon} aria-label={t('Close')} />
        </CloseButton>
      </PanelHeader>
      <PanelBody showScrollbar={showScrollbar} panelBodyBottom={panelBodyBottom}>
        {children}
      </PanelBody>
      <PanelFooter>
        {footer}
      </PanelFooter>
    </Panel>
  </Container>
);

LeftSideBar.propTypes = {
  isOpen: PropTypes.bool,
  toggleMenu: PropTypes.func,
  children: PropTypes.node,
  footer: PropTypes.node,
  showScrollbar: PropTypes.bool,
  panelBodyBottom: PropTypes.node,
};

export default LeftSideBar;

